import {useState}  from 'react';

// Hook implementation of the localStorage : the goal is to re-render the component who use the hook if the value has changed in the local storage
function useLocalStorage(key, initialValue = '') {

    const [storedValue, setStoredValue] = useState(()  =>{
        if (typeof window === "undefined") {
            return initialValue;
        }
        try {

            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            
            console.log(error);
            return initialValue;
      }
    });

    const setValue = (value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;

            setStoredValue(valueToStore);

            if (typeof window === "undefined") {
                return null;
            }

            window.localStorage.setItem(key, JSON.stringify(valueToStore));

        } catch (error) {
            console.log(error);
        }
    };
    return [storedValue, setValue];
}

export default useLocalStorage;
